import TxpEntitiesState from '../../schema/innerSchema/TxpEntitiesState';

export default function getTxpEntitiesStateFromString(state: string): TxpEntitiesState {
    switch (state) {
        case 'InitialProcessing': {
            return TxpEntitiesState.InitialProcessing;
        }

        case 'EmailProcessingOnly': {
            return TxpEntitiesState.EmailProcessingOnly;
        }

        case 'Processed': {
            return TxpEntitiesState.Processed;
        }

        case 'AddToCalendar': {
            return TxpEntitiesState.AddToCalendar;
        }

        case 'RemoveFromCalendar': {
            return TxpEntitiesState.RemoveFromCalendar;
        }

        case 'PermanentError': {
            return TxpEntitiesState.PermanentError;
        }

        case 'ClearedByRecovery': {
            return TxpEntitiesState.ClearedByRecovery;
        }

        case 'IgnoredByDesign': {
            return TxpEntitiesState.IgnoredByDesign;
        }

        case 'ProcessedWithNoData': {
            return TxpEntitiesState.ProcessedWithNoData;
        }

        case 'SaveUserEdits': {
            return TxpEntitiesState.SaveUserEdits;
        }

        default: {
            return TxpEntitiesState.None;
        }
    }
}
